const getEnv = (name: string): string => {
  const value = import.meta.env[name] as string;
  if (!value) {
    throw new Error(`Missing required env var: ${name}`);
  }
  return value;
};

export const getOptionalEnv = (name: string): string | undefined => {
  const value = import.meta.env[name] as string | undefined;
  return value || undefined;
};

/**
 * Returns the API base URL. An empty string means same-origin (relative URLs),
 * which is how CloudFront-hosted builds talk to the ALB via the distribution's
 * API behaviors. Local dev sets this to `http://localhost:${API_PORT}` via
 * `vite.config.ts`.
 *
 * Use this helper instead of `getEnv('VITE_API_SERVER_URL')` — the latter
 * throws when the value is an empty string, which breaks same-origin builds.
 */
export const getApiBaseUrl = (): string => {
  const value = import.meta.env.VITE_API_SERVER_URL as string | undefined;
  return value ?? '';
};

export default getEnv;
